import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/professional/pro-xg-10-poe.png";
import { type Product } from "../../types";
import { switchingProfessional } from "../product-list-groups/switchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  poeAvailability,
  poeOutput,
  portCount,
  proAvSupport,
  uplinkSpeed,
} from "../properties";

export const professionalXg10PoE: Product = {
  id: "professionalXg10PoE",
  productTitle: "Pro XG 10 PoE",
  description: "professionalXg10PoE.description",
  storePathParts: {
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
    productSlug: "usw-pro-xg-10-poe",
  },
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/usw-pro-xg-10-poe`,
  ],
  image: { src: image, width: 200, height: 140 },
  productListGroup: switchingProfessional,
  isNew: true,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442.4 x 285 x 44 mm\n(17.4 x 11.2 x 1.7")',
      },
    },
    {
      propertyId: portCount.id,
      value: {
        type: "string",
        value: "10 + 2 SFP+",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "string",
        value: "10 Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "string",
        value: "10 Gbps",
      },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "string",
        value: "PoE+++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: {
        type: "string",
        value: "400 W",
      },
    },
    {
      propertyId: etherlighting.id,
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: proAvSupport.id,
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.dcPowerBackup",
      },
    },
    {
      propertyId: "mounting",
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
  ],
};
